import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3e8fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forms" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日付", -1))
const _hoisted_4 = { class: "input" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "タイトル", -1))
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "本文", -1))
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-submit" }, "キャンセル", -1))

import { computed, PropType, ref } from 'vue'
import moment from 'moment'
import DatePicker from '@/components/common/DatePicker.vue'
import NewsItem from '@/models/NewsItem'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Object as PropType<NewsItem>,
    required: true,
  },
},
  emits: ['update:modelValue', 'submit'],
  setup(__props, { emit }) {

const props = __props


const newsItem = ref<NewsItem>(props.modelValue)


const date = computed({
  get() {
    return moment(props.modelValue.time).toDate()
  },

  set(date) {
    if (!newsItem.value) {
      return
    }

    newsItem.value.time = moment(date).format()
    // emit('update:modelValue', newsItem.value)
  },
})
const title = computed({
  get() {
    return props.modelValue.title
  },

  set(title) {
    if (!newsItem.value) {
      return
    }

    newsItem.value.title = title
    // emit('update:modelValue', newsItem.value)
  },
})
const description = computed({
  get() {
    return props.modelValue.description
  },

  set(description) {
    if (!newsItem.value) {
      return
    }

    newsItem.value.description = description
    // emit('update:modelValue', newsItem.value)
  },
})

const errMsg = ref({
  title: '',
  description: '',
})

const validate = () => {
  let valid = true

  if (title.value.trim()) {
    errMsg.value.title = ''
  } else {
    errMsg.value.title = 'タイトルを入力してください。'

    valid = false
  }

  if (description.value.trim()) {
    errMsg.value.description = ''
  } else {
    errMsg.value.description = '本文を入力してください。'

    valid = false
  }

  return valid
}

const submit = () => {
  if (!validate()) {
    return
  }

  emit('submit')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(DatePicker, {
            modelValue: _unref(date),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(date) ? (date).value = $event : null)),
            "show-hour": true,
            "show-minutes": true
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", null, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(title) ? (title).value = $event : null)),
          type: "text"
        }, null, 512), [
          [_vModelText, _unref(title)]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(errMsg.value.title), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, [
        _hoisted_9,
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(description) ? (description).value = $event : null)),
          cols: "30",
          rows: "10"
        }, null, 512), [
          [_vModelText, _unref(description)]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(errMsg.value.description), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        onClick: submit,
        class: "btn btn-submit"
      }, "決定"),
      _createVNode(_component_router_link, { to: "/settings/information" }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ])
  ]))
}
}

})